import {Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output} from '@angular/core';

@Component({
  selector: 'tc-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class TCPaginationComponent implements OnInit, OnChanges {
  @HostBinding('class.tc-pagination') true;

  @Input() pagesNumber: number;
  @Input() pageNum: number;

  @Output() goToPage: EventEmitter<number> = new EventEmitter<number>();

  pages: Array<any>;

  constructor() {
    this.pagesNumber = 1;
    this.pageNum = 1;
  }

  public changePage(page: number) {
    this.pageNum = page;
    this.goToPage.emit(page);
  }

  public nextPage() {
    if (this.pageNum < this.getLast()) {
      this.pageNum++;
      this.goToPage.emit(this.pageNum);
    }
  }

  public prevPage() {
    if (this.pageNum > 1) {
      this.pageNum--;
      this.goToPage.emit(this.pageNum);
    }
  }

  ngOnInit() {
    this.pages = this.pagination(this.pageNum, this.pagesNumber);
    // this.pages = Array.from(Array(this.pagesNumber), (x, i) => i + 1);
    // console.log('pagination', this.pages);
  }

  dotClick() {
  }

  pagination(currentPage, pageCount) {

    const delta = 4;

    let range = [];
    for (let i = Math.max(2, currentPage - delta); i <= Math.min(pageCount - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      range.unshift('...');
    }
    if (currentPage + delta < pageCount - 1) {
      range.push('...');
    }

    range.unshift(1);
    range.push(pageCount);

    return range;


    /* const delta = 2;
     const left = currentPage - delta,
       right = currentPage + delta + 1;
     let result = [];

     result = Array.from({length: pageCount}, (v, k) => k + 1)
       .filter(i => i && i >= left && i < right);

     if (result.length > 1) {
       // Add first page and dots
       if (result[0] > 1) {
         if (result[0] > 2) {
           result.unshift('...');
         }
         result.unshift(1);
       }

       // Add dots and last page
       if (result[result.length - 1] < pageCount) {
         if (result[result.length - 1] !== pageCount - 1) {
           result.push('...');
         }
         result.push(pageCount);
       }
     }

     return result;*/
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  getLast(): number {
    return this.pages[this.pages.length - 1];
  }
}
